import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const CustomCalendar = ({ selectedDate, setSelectedDate, minDate }) => {
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setShowCalendar(false);
    };

    const handleInputClick = () => {
        setShowCalendar(!showCalendar);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div ref={calendarRef} className="relative">
            <input
                type="text"
                value={selectedDate ? selectedDate.toLocaleDateString() : ''}
                onClick={handleInputClick}
                readOnly
                className="w-full p-2 border border-gray-300 mb-4 sm:mb-0 rounded focus:border-[#1E88E5] focus:outline-none text-sm font-lato"
            />
            {showCalendar && (
                <div className="absolute z-50 mt-1 w-full">
                    <DatePicker
                        selected={selectedDate}
                        onChange={handleDateChange}
                        minDate={new Date(minDate)}
                        inline
                    />
                </div>
            )}
        </div>
    );
};

export default CustomCalendar;
